/**
 * Проверка JS-объекта на null или undefined
 */
export function isNullOrUndefined(val) {
  return val === null || val === undefined
}

/**
 * Проверка JS-объекта на пустоту.
 *
 * (!) Не следует использовать с типами Number и Object. Для этого есть !_.isEmpty из библиотеки lodash
 */
export function isNotEmpty(val) {
  return !isNullOrUndefined(val) && val.length > 0
}

/**
 * Проверка JS-объекта на непустоту.
 *
 * (!) Не следует использовать с типами Number и Object. Для этого есть _.isEmpty из библиотеки lodash
 */
export function isEmpty(val) {
  return !isNotEmpty(val);
}

/**
 * Устанавливает определённое значение во все имеющиеся поля объекта или во все элементы массива
 * (!) Метод изменяет исходный объект
 * (!) null останется равным null, undefined останется равным undefined
 */
export function setAll(obj, val) {
  if (obj === null || obj === undefined) {
    return;
  }

  Object.keys(obj).forEach(index => {
    obj[index] = val
  });
}

/**
 * Устанавливает null во все имеющиеся поля объекта или во все элементы массива
 * (!) Метод изменяет исходный объект
 * (!) null останется равным null, undefined останется равным undefined
 */
export function nullify(obj) {
  setAll(obj, null);
}